import axiosHttpRequest from "../axios";

async function getSFTOReconciliationMainDetails(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  )
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function getSFTOReconciliationCompletedDetails(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  )
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function inserSFTOReconciliationDetails(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}
async function getSFTOReconciliationTmillDetails(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  )
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function inserSFTOReconciliationDetailsTmill(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}
async function getSFTOReconciliationCustomerDetails(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  )
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function inserSFTOReconciliationDetailsCustomer(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getSFTOReconciliationInsuranceDetails(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  )
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function inserSFTOReconciliationDetailsInsurance(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}
async function getSFTOReconciliationRailwaysDetails(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  )
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function inserSFTOReconciliationDetailsRailways(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getReconciliationMaster(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

export default {
  getSFTOReconciliationMainDetails,
  getSFTOReconciliationCompletedDetails,
  inserSFTOReconciliationDetails,
  getSFTOReconciliationTmillDetails,
  inserSFTOReconciliationDetailsTmill,
  getSFTOReconciliationCustomerDetails,
  inserSFTOReconciliationDetailsCustomer,
  getSFTOReconciliationInsuranceDetails,
  inserSFTOReconciliationDetailsInsurance,
  getSFTOReconciliationRailwaysDetails,
  inserSFTOReconciliationDetailsRailways,
  getReconciliationMaster,
};
